/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { ScenarioChatFormQueryFragmentDoc, ScenarioChatFragmentDoc } from '../../components/organisms/ScenarioChatForm/ScenarioChatForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ScenarioChatMessageBasicSelectionInput = {
  actions: Array<ScenarioChatMessageSelectionActionInput>;
  guid?: string | number | null | undefined;
  label: string;
  nextMessageIndex?: number | null | undefined;
};

export type ScenarioChatMessageBookingRequestSelectionsInput = {
  fallbackUrl?: string | null | undefined;
  guid?: string | number | null | undefined;
};

export type ScenarioChatMessageInput = {
  body: string;
  guid?: string | number | null | undefined;
  selections: Array<ScenarioChatMessageSelectionInput>;
  selectionsV2?: ScenarioChatMessageSelectionsInput | null | undefined;
};

export type ScenarioChatMessageSelectionActionInput = {
  /** oneof */
  assignPlannerAccountToMatch?: ScrnarioChatMessageSelectionActionAssignPlannerAccountToMatchInput | null | undefined;
};

export type ScenarioChatMessageSelectionInput = {
  actions: Array<ScenarioChatMessageSelectionActionInput>;
  guid?: string | number | null | undefined;
  label: string;
  nextMessageIndex?: number | null | undefined;
};

export type ScenarioChatMessageSelectionsInput = {
  /** oneof */
  basicSelections?: Array<ScenarioChatMessageBasicSelectionInput> | null | undefined;
  bookingRequestSelections?: ScenarioChatMessageBookingRequestSelectionsInput | null | undefined;
};

export type ScrnarioChatMessageSelectionActionAssignPlannerAccountToMatchInput = {
  assignedPlannerAccountId?: string | number | null | undefined;
  assignedStaffGUID: string | number;
  guid?: string | number | null | undefined;
};

export type UpdateScenarioChatInput = {
  guid: string | number;
  messages: Array<ScenarioChatMessageInput>;
  title: string;
};

export type ScenarioChatPageQueryVariables = Exact<{
  guid: string | number;
}>;


export type ScenarioChatPageQuery = { scenarioChat: { scenarioChat: { guid: string, title: string, messages: Array<{ guid: string, body: string, selectionsV2:
          | { __typename: 'ScenarioChatMessageBasicSelections', basicSelections: Array<{ guid: string, label: string, nextMessageIndex: number | null, actions: Array<{ assignedStaffGUID: string }> }> }
          | { __typename: 'ScenarioChatMessageBookingRequestSelections', fallbackUrl: string | null }
         | null }> } }, staffsByPlanner: Array<{ guid: string, displayName: string }> };

export type UpdateScenarioChatMutationVariables = Exact<{
  input: Types.UpdateScenarioChatInput;
}>;


export type UpdateScenarioChatMutation = { updateScenarioChat: { guid: string } };


export const ScenarioChatPageDocument = gql`
    query ScenarioChatPage($guid: ID!) {
  scenarioChat(guid: $guid) {
    scenarioChat {
      ...ScenarioChat
    }
  }
  ...ScenarioChatFormQuery
}
    ${ScenarioChatFragmentDoc}
${ScenarioChatFormQueryFragmentDoc}`;

/**
 * __useScenarioChatPageQuery__
 *
 * To run a query within a Vue component, call `useScenarioChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioChatPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useScenarioChatPageQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useScenarioChatPageQuery(variables: ScenarioChatPageQueryVariables | VueCompositionApi.Ref<ScenarioChatPageQueryVariables> | ReactiveFunction<ScenarioChatPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ScenarioChatPageQuery, ScenarioChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>(ScenarioChatPageDocument, variables, options);
}
export function useScenarioChatPageLazyQuery(variables?: ScenarioChatPageQueryVariables | VueCompositionApi.Ref<ScenarioChatPageQueryVariables> | ReactiveFunction<ScenarioChatPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ScenarioChatPageQuery, ScenarioChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>(ScenarioChatPageDocument, variables, options);
}
export type ScenarioChatPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ScenarioChatPageQuery, ScenarioChatPageQueryVariables>;
export const UpdateScenarioChatDocument = gql`
    mutation UpdateScenarioChat($input: UpdateScenarioChatInput!) {
  updateScenarioChat(input: $input) {
    guid
  }
}
    `;

/**
 * __useUpdateScenarioChatMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioChatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioChatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateScenarioChatMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScenarioChatMutation(options: VueApolloComposable.UseMutationOptions<UpdateScenarioChatMutation, UpdateScenarioChatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateScenarioChatMutation, UpdateScenarioChatMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateScenarioChatMutation, UpdateScenarioChatMutationVariables>(UpdateScenarioChatDocument, options);
}
export type UpdateScenarioChatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateScenarioChatMutation, UpdateScenarioChatMutationVariables>;